import { configureStore } from "@reduxjs/toolkit";
import sessionReducer from "./Features/Session/SessionSlice";
import labelsReducer from "./Features/Labels/LabelsSlice";
import walletReducer from "./Features/Wallet/WalletSlice";
import exchangeReducer from "./Features/Exchange/ExchangeSlice";
import marketReducer from "./Features/Market/marketSlice";
import orderReducer from "./Features/Order/orderSlice";
import tradeReducer from "./Features/Trade/tradeSlice";
import convertReducer from "./Features/Convert/convertSlice";
import priceReducer from "./Features/Price/PriceSlice";
import userReducer from "./Features/User/UserSlice";
import earnReducer from "./Features/EarnCampaign/earnSlice";

const store = configureStore({
  reducer: {
    session: sessionReducer,
    labels: labelsReducer,
    wallet: walletReducer,
    exchange: exchangeReducer,
    market: marketReducer,
    order: orderReducer,
    trade: tradeReducer,
    convert: convertReducer,
    price: priceReducer,
    user: userReducer,
    earn: earnReducer,
  },
});

export default store;
